import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { getRefreshToken } from "../../../auth/AuthUtility";

export type ProtectedRouteProps = {
    isAuthenticated: boolean;
    isLoading: boolean;
    authenticationPath: string;
} & RouteProps;

const ProtectedRoute = ({isAuthenticated, isLoading, authenticationPath, ...routeProps}: ProtectedRouteProps) => {
    // loading is relevant only when it's a logged user
    if (getRefreshToken() && isLoading) return null;

    if (isAuthenticated) {
        return <Route {...routeProps} />;
    } else {
        return <Redirect to={{pathname: authenticationPath}} />;
    }
};

export default ProtectedRoute;
